<script>
import * as types from '@/store/types'

export default {
  mounted () {
    if (!this.dontClearBreadcrumb)
      this.$store.commit(types.SET_BREADCRUMB, [])
  },
  methods: {
    commitBreadcrumb (items) {
      this.$store.commit(types.SET_BREADCRUMB, items)
    }
  }
}
</script>
